import jQuery from 'jquery';
import 'slick-carousel';

// promoted products
jQuery('.promoted-products-carousel').slick({
  dots: true,
  infinite: true,
  prevArrow: jQuery('.promoted-products-arrow-left'),
  nextArrow: jQuery('.promoted-products-arrow-right'),
  slidesToScroll: 4,
  slidesToShow: 4,
  autoplay: true,
  autoplaySpeed: 5000,
  responsive: [
    {
      breakpoint: 1480,
      settings: {
        slidesToScroll: 3,
        slidesToShow: 3
      }
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToScroll: 2,
        slidesToShow: 2
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 1,
        centerMode: true
      }
    }
  ]
});

// grouped products
jQuery('.products-listing-carousel').each(function() {
  jQuery(this).slick({
    dots: true,
    infinite: true,
    prevArrow: jQuery(this).next('.carousel-arrows-container').children('.products-listing-arrow-left'),
    nextArrow: jQuery(this).next('.carousel-arrows-container').children('.products-listing-arrow-right'),
    slidesToScroll: 4,
    slidesToShow: 4,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
      breakpoint: 1480,
      settings: {
        slidesToScroll: 3,
        slidesToShow: 3
      }
    },
      {
        breakpoint: 1200,
        settings: {
          slideToScroll: 2,
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          centerMode: true,
          slidesToScroll: 1,
          slidesToShow: 1
        }
      }
    ]
  });
});




// // continental products
// jQuery('.products-group--continental .products-listing-carousel').slick({
//   infinite: true,
//   slidesToShow: 4,
//   dots: true,
//   slidesToScroll: 1,
//   centerMode: false,
//   prevArrow: jQuery('.products-group--continental .products-listing-arrow-left'),
//   nextArrow: jQuery('.products-group--continental .products-listing-arrow-right'),
//   responsive: [
//     {
//       breakpoint: 1200,
//       settings: {
//         slidesToShow: 2,
//       }
//     },
//     {
//       breakpoint: 768,
//       settings: {
//         slidesToShow: 1,
//         centerMode: true
//       }
//     }
//   ]
// });
//
// // bestdrive products
// jQuery('.products-group--bestdrive .products-listing-carousel').slick({
//   infinite: true,
//   slidesToShow: 4,
//   dots: true,
//   slidesToScroll: 1,
//   centerMode: false,
//   prevArrow: jQuery('.products-group--bestdrive .products-listing-arrow-left'),
//   nextArrow: jQuery('.products-group--bestdrive .products-listing-arrow-right'),
//   responsive: [
//     {
//       breakpoint: 1200,
//       settings: {
//         slidesToShow: 2,
//       }
//     },
//     {
//       breakpoint: 768,
//       settings: {
//         slidesToShow: 1,
//         centerMode: true
//       }
//     }
//   ]
// });
//
// // uniroyal products
// jQuery('.products-group--uniroyal .products-listing-carousel').slick({
//   infinite: true,
//   slidesToShow: 4,
//   dots: true,
//   slidesToScroll: 1,
//   centerMode: false,
//   prevArrow: jQuery('.products-group--uniroyal .products-listing-arrow-left'),
//   nextArrow: jQuery('.products-group--uniroyal .products-listing-arrow-right'),
//   responsive: [
//     {
//       breakpoint: 1200,
//       settings: {
//         slidesToShow: 2,
//       }
//     },
//     {
//       breakpoint: 768,
//       settings: {
//         slidesToShow: 1,
//         centerMode: true
//       }
//     }
//   ]
// });
//
// // barum products
// jQuery('.products-group--barum .products-listing-carousel').slick({
//   infinite: true,
//   slidesToShow: 4,
//   dots: true,
//   slidesToScroll: 1,
//   centerMode: false,
//   prevArrow: jQuery('.products-group--barum .products-listing-arrow-left'),
//   nextArrow: jQuery('.products-group--barum .products-listing-arrow-right'),
//   responsive: [
//     {
//       breakpoint: 1200,
//       settings: {
//         slidesToShow: 2,
//       }
//     },
//     {
//       breakpoint: 768,
//       settings: {
//         slidesToShow: 1,
//         centerMode: true
//       }
//     }
//   ]
// });
